import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class settingsColumn extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "settingColumn", title: "Setting" },
        { name: "selectColumn", title: "Select" },
      ],
      rows: [
        { settingColumn: 'Port Mapping aktiviert', selectColumn: 'Ja' },
        { settingColumn: 'Hairpinning aktivieren', selectColumn: 'Ja' },
        { settingColumn: 'Beschreibung', selectColumn: 'Wählen Sie einen Namen für Ihre Kamera, z. B. _Camera Entrance' },
        { settingColumn: 'Schnittstelle Typ', selectColumn: 'Unspezifizierter' },
        { settingColumn: 'Schnittstelle', selectColumn: 'PPP - PPP über ATM' },
        { settingColumn: 'Jeden Host', selectColumn: 'Ja' },
        { settingColumn: 'Jeden Port', selectColumn: 'Nein' },
        { settingColumn: 'Externer Port', selectColumn: 'TCP - 8081 - 8081 (Für die zweite Kamera wählen Sie 8082, usw.)' },
        { settingColumn: 'Local Host', selectColumn: 'Geben Sie hier die lokale IP-Adresse Ihrer Kamera ein' },
        { settingColumn: 'denselben Port', selectColumn: 'Ja' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

settingsColumn.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(settingsColumn)